import PropTypes from 'prop-types';
import DashboardNoRecord from '../DashboardNoRecord/DashboardNoRecord';
import DashboardSubscriptionsTableRow from './DashboardSubscriptionsTableRow';

function DashboardSubscriptionsTable({
  subscriptions,
  handleOpenManageSubscription,
}) {
  return (
    <div className="mt-4 rounded-lg border border-rcgray-200 bg-rcgray-50/50 p-4 shadow-md">
      <table className="min-w-full divide-y divide-gray-300">
        <thead>
          <tr>
            <th
              scope="col"
              className="py-3.5 pr-3 pl-4 text-left font-semibold text-gray-900 text-sm sm:pl-0"
            >
              Details
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm lg:table-cell"
            >
              Enrolled
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
            >
              Renewal
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left font-semibold text-gray-900 text-sm sm:table-cell"
            >
              Payment Info
            </th>
            <th scope="col" className="py-3.5 pr-4 pl-3 sm:pr-0">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {subscriptions.length > 0 ? (
            subscriptions.map((subscription) => (
              <DashboardSubscriptionsTableRow
                key={subscription.id}
                subscription={subscription}
                handleOpenModal={handleOpenManageSubscription}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5} className="py-4">
                <DashboardNoRecord text="Sorry, you don't have any active plans yet." />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

DashboardSubscriptionsTable.propTypes = {
  subscriptions: PropTypes.array.isRequired,
  handleOpenManageSubscription: PropTypes.func.isRequired,
};

export default DashboardSubscriptionsTable;
